import { Button, Grid, Paper, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/system";
import { Form, Input } from "antd";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client"; 
import Message from "../../Components/Message";
import { RESET_PASSWORD } from "../../Graphql/Mutations";
import { CommonPaths } from "../../Routes/Paths";
import { Error } from "../../Types/MessageType";

const ResetPassword = () => {
  const theme = useTheme();
  const [form] = Form.useForm();
  const [alert, setAlert] = useState<Error>();
  const { token } = useParams<{ token: string }>(); 
  const navigate = useNavigate();
  const [resetPassword] = useMutation(RESET_PASSWORD);

  const resetPasswordHandler = async (values: { password: string; confirmPassword: string }) => {
    if (values.password !== values.confirmPassword) {
      setAlert({
        type: 'error',
        message: 'Passwords do not match!',
      });
      return;
    }

    try {
      const { data } = await resetPassword({
        variables: {
          token, 
          newPassword: values.confirmPassword, 
        },
      });

      if (data.resetPassword.success) {
        setAlert({
          type: 'success',
          message: data.resetPassword.message,
        });

        // Redirect to SIGNIN_PATH after success
        setTimeout(() => {
          navigate(CommonPaths.SIGNIN_PATH); 
        }, 1000); 
      } else {
        setAlert({
          type: 'error',
          message: data.resetPassword.message,
        });
      }
    } catch (error: any) {
      setAlert({
        type: 'error',
        message: error.message || 'An error occurred while resetting the password.',
      });
    }
  };

  return (
    <Grid container height={"100%"} sx={{ minHeight: '700px' }} width={'100vw'} justifyContent="center" alignItems="center" px={{ sm: 2, md: 20 }}>
      <Grid item md={6}>
        <Paper elevation={2} sx={{ backgroundColor: theme.palette.background.paper, pt: 8, pb: 8, px: 4, marginTop: '35px' }}>
          <Typography color={'primary'} textAlign={'center'} variant={'h5'} sx={{ mb: 3 }}>
            Reset Password
          </Typography>
          <Form
            form={form}
            layout={'vertical'}
            style={{ padding: '0 10%' }}
            onFinish={resetPasswordHandler}
          >
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please input your password' }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              name="confirmPassword"
              rules={[{ required: true, message: 'Please confirm your password' }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item style={{ marginTop: '10px', marginBottom: '-30px' }}>
              <Button type={'submit'} variant={'contained'} style={{ margin: '0 40%', color: 'white', height: '45px' }}>
                Submit
              </Button>
            </Form.Item>
          </Form>
          <Box height={theme.status.errorMessageSpace}>
            {!!alert?.message ? <Message type={alert?.type} message={alert.message} /> : null}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;